import { CHARGE_POINT_ROUTES } from 'shared/consts/routes/charge-point';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddChargePointButton() {
  return (
    <MenuAddButton
      label="Добавить ЭЗС"
      path={CHARGE_POINT_ROUTES.ADD_CHARGE_POINT}
      requiredRights={[
        {
          controller: 'ChargePoint',
          right: 'Write',
        },
      ]}
    />
  );
}
